<div>
  <his-search-result #SearchResultComponent
    [showTitle]="false"
    [showNewSearchButton]="false"
    [showChangeSearchButton]="false"
    idColumn="Unit.id"
    defaultColumn="Unit.defaulttext">
    @if (showBackButton) {
      <ng-container customResultButtons>
        <button (click)="back()"><span>{{'common.back' | hisUi }}</span></button>
      </ng-container>
    }
    <ng-template #rowAction let-index="index" let-row="row">
      <!-- detail view -->
      <a href="../../pages/startFlow.xhtml?_flowId=detailView-flow&unitId={{row.get('Unit.id')}}&navigationPosition=studiesOffered,searchCourses" hisImage="magnifier_detail" [title]="'de.his.javang.show' | hisUi"></a>
    </ng-template>
  </his-search-result>
</div>
